import CheckIcon from '@mui/icons-material/Check';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { forwardRef, MouseEvent, useState } from 'react';
import { useStore } from 'react-admin';
import { THEME_MODE_KEY, THEME_MODES, ThemeMode } from './themes';

/** The user menu's Theme entry: it opens a small menu of Light, Dark and System, the current one ticked. */
const ThemeMenu = forwardRef<HTMLLIElement>((_, ref) => {
  const [mode, setMode] = useStore<ThemeMode>(THEME_MODE_KEY, 'light');
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const open = (event: MouseEvent<HTMLElement>) => setAnchor(event.currentTarget);
  const label = THEME_MODES.find((option) => option.mode === mode)?.label ?? 'Light';

  return (
    <>
      <MenuItem ref={ref} onClick={open} aria-haspopup="menu" aria-expanded={anchor !== null}>
        <ListItemIcon>
          <PaletteOutlinedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Theme" secondary={label} />
        <ChevronRightIcon fontSize="small" sx={{ ml: 2, color: 'text.secondary' }} />
      </MenuItem>
      <Menu anchorEl={anchor} open={anchor !== null} onClose={() => setAnchor(null)} anchorOrigin={{ vertical: 'top', horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
        {THEME_MODES.map((option) => (
          <MenuItem
            key={option.mode}
            selected={option.mode === mode}
            onClick={() => {
              setMode(option.mode);
              setAnchor(null);
            }}
          >
            <ListItemIcon>{option.mode === mode && <CheckIcon fontSize="small" />}</ListItemIcon>
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
});

ThemeMenu.displayName = 'ThemeMenu';

export default ThemeMenu;
